/* Layout */
import Layout from '@/views/layout/Layout';

export default [{
    path: '/couponManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '优惠券',
      icon: 'component',
    },
    children: [{
      path: '/couponManage/couponModel',
        component: () => import('@/myviews/coupon/coupon_model/couponModel'),
        name: '优惠券模板',
        meta: {
          title: '优惠券模板',
          icon: 'component',
          alwaysShow: false,
          roles: ['12', "123"], //添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/couponManage/createCouponModel',
        component: () => import('@/myviews/coupon/coupon_model/createCouponModel/createCouponModel'),
        name: 'createCouponModel',
        hidden: true,
        meta: {
          title: '创建优惠券模板',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
        }
      },
      {
        path: '/couponManage/couponShop',
        component: () => import('@/myviews/coupon/coupon_shop/couponShop'),
        name: '商城优惠券',
        meta: {
          title: '商城优惠券',
          icon: 'component',
          alwaysShow: false,
          roles: ['12', "123"], //添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/couponManage/couponSend',
        component: () => import('@/myviews/coupon/coupon_shop/couponSend/couponSend'),
        alwaysShow: false,
        name: 'couponSend',
        hidden: true,
        meta: {
          title: '优惠券发放',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/couponManage/couponGet',
        component: () => import('@/myviews/coupon/coupon_shop/couponSend/couponSend'),
        alwaysShow: false,
        name: 'couponGet',
        hidden: true,
        meta: {
          title: '优惠券领取',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      }, 
      {
        path: '/couponManage/couponClassify',
        component: () => import('@/myviews/coupon/coupon_classify/couponClassify'),
        name: '券分类管理',
        meta: {
          title: '券分类管理',
          icon: 'component',
          alwaysShow: false,
          roles: ['12', "123"], //添加   修改   查看页面
          have: [],
        }
      },  
      {
        path: '/couponManage/coupon_detalis',
        component: () => import('@/myviews/coupon/coupon_detalis/coupon_detalis'),
        alwaysShow: false,
        name: 'couponDetalis',
        hidden: true,
        meta: {
          title: '优惠券数据',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/couponManage/coupon_activityManager',
        component: () => import('@/myviews/coupon/coupon_activityManager'),
        alwaysShow: false,
        name: 'couponActivityManager',
        meta: {
          title: '优惠券活动管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      },
      {
        path: '/couponManage/coupon_activityManager/activityDetails',
        component: () => import('@/myviews/coupon/coupon_activityManager/activityDetails'),
        alwaysShow: false,
        name: 'couponActivityManagerDetails',
        hidden: true,
        meta: {
          title: '新增/编辑活动',
          icon: 'component',
          roles: ['add', "modify", "viewpage"], //添加   修改   查看页面
          have: [],
        }
      }
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/nurseManage/coupon.js